<template>
  <div class="poll_box">
    <h4>{{ title }}</h4>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'AgreementPollbox',
  props: {
    title: {
      type: String,
      default: '???',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/agreement/main/partial/AgreementPollbox.vue